import React, { useState, useEffect, useRef, Fragment, useCallback } from 'react';
import ProtectedRoute from '../../routes/protected';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import performanceService from '../../services/data/performance.service';
import moment from "moment";
import 'moment/locale/pt-br'
import { Toast } from 'primereact/toast';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import { useParams, useLocation } from 'react-router-dom';
import { Avatar } from 'primereact/avatar';
import NameInitials from '../../helpers/nameInitials';
import SkeletonProcess from './skeletonProcess';
import PerformanceReportStepCommentsRows, {
    performanceReportStepResponsesAvailable,
} from './performanceReportStepComments';
import useCompanyData from '../../context/company';


export default function PerformanceReviewReport() {

    const { rootUser } = useCompanyData();
    const [responsesOpenKey, setResponsesOpenKey] = useState(null);
    const [pageLoad, setPageLoad] = useState(true)
    const toast = useRef(null);
    const [object, setObject] = useState([]);
    const [report, setReport] = useState('')

    const { id } = useParams()
    const location = useLocation()

    // remover employee do processo
    const [reviewId, setReviewId] = useState('')
    const [employeeManagerName, setEmployeeManagerName] = useState('')
    const [employeeManagerId, setEmployeeManagerId] = useState('')
    const [deleteEmployeeId, setDeleteEmployeeId] = useState('')
    const [deleteEmployeeName, setDeleteEmployeeName] = useState('')

    const modalRef = useRef()

    const hideModal = () => {
        const modalEl = modalRef.current
        const bsModal= bootstrap.Modal.getInstance(modalEl)
        bsModal.hide()
    }

    function deleteItem() {
        var data = {
            managerId: employeeManagerId,
            employeeId: deleteEmployeeId,
            id: reviewId,
            company_id: localStorage.getItem("companyId")
        }
        performanceService.removePerformanceProcess(data).then(() => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Participante removido com sucesso', life: 3000 });
            getReport()
        })
        .catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 });
        })
        .finally(() => {
            hideModal()
        })
    }

    const getReport = useCallback(() => {
        let data = {
            id: id,
            company_id: localStorage.getItem("companyId")
        }
        performanceService.getPerformanceReviewReport(data).then((response) => {

            setReport(response)
            setPageLoad(false)
        })
    }, [id])

    useEffect(() => {
        if (location && location.state && location.state.item) {
            setObject(location.state.item)
        }
        getReport()
    }, [location, getReport])

    const STATUS_MAP = {
        'NI': 'Não Iniciado',
        'PE': 'Em Andamento',
        'RE': 'Realizado',
    }

    const PERFORMANCE_STATUS_MAP = {
        'AT': 'Ativo',
        'EP': 'Em Processo',
        'CO': 'Concluído',
        'AR': 'Arquivado',
        'CA': 'Cancelado',
    }

    const styles = {
        minHeight: '500px',
        paddingBottom: '200px'
    }

    function exportReport() {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id,
        }
        performanceService.exportPerformanceReviewReport(data).then((response) => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: response.message, life: 4000 });
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 10000 });
        })
    }

    function exportEmployeeXLS(employee) {
        const data = {
            company_id: localStorage.getItem("companyId"),
            review_id: report.review_id,
            employee_id: employee.employee_id,
        }
        performanceService.exportEmployeeReviewReport(data).then((response) => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: response.message, life: 4000 });
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Ops', detail: JSON.stringify(error.response?.data), life: 10000 });
        })
    }

    function printEmployeePDF(employee) {
        const steps = (employee.steps || []).filter(s => s.step_type !== 'AS');

        const itemsMap = new Map();
        for (const step of steps) {
            for (const sess of (step.step_item_sessions || [])) {
                for (const item of (sess.items || [])) {
                    if (!itemsMap.has(item.item_id)) {
                        itemsMap.set(item.item_id, {
                            title: item.item_title || '-',
                            sessionTitle: sess.session_title || '',
                            sessionOrder: sess.session_order ?? 0,
                        });
                    }
                }
            }
        }

        const sortedItems = [...itemsMap.entries()].sort(
            ([, a], [, b]) => a.sessionOrder - b.sessionOrder || a.sessionTitle.localeCompare(b.sessionTitle)
        );

        const stripHtml = (html) => (html || '').replace(/<[^>]+>/g, '').trim() || '-';

        const stepHeaders = steps.map(s =>
            `<th colspan="2" style="background:#388e3c;color:#fff;padding:6px 8px;border:1px solid #ccc;">${s.step_title}</th>`
        ).join('');

        const stepSubHeaders = steps.map(() =>
            `<th style="background:#e8f5e9;padding:5px 8px;border:1px solid #ccc;">Nota</th><th style="background:#e8f5e9;padding:5px 8px;border:1px solid #ccc;">Comentário</th>`
        ).join('');

        const dataRows = sortedItems.map(([itemId, itemInfo]) => {
            const cells = steps.map(step => {
                let nota = '-', comentario = '-';
                for (const sess of (step.step_item_sessions || [])) {
                    const found = (sess.items || []).find(it => it.item_id === itemId);
                    if (found) {
                        if (found.rating_label) {
                            nota = found.rating_score !== null && found.rating_score !== ''
                                ? `${found.rating_label} (${found.rating_score}/5)`
                                : found.rating_label;
                        }
                        if (found.comment) {
                            comentario = stripHtml(found.comment);
                        }
                        break;
                    }
                }
                return `<td style="padding:5px 8px;border:1px solid #ddd;vertical-align:top;">${nota}</td><td style="padding:5px 8px;border:1px solid #ddd;vertical-align:top;">${comentario}</td>`;
            }).join('');

            return `<tr>
                <td style="padding:5px 8px;border:1px solid #ddd;vertical-align:top;">${itemInfo.sessionTitle}</td>
                <td style="padding:5px 8px;border:1px solid #ddd;vertical-align:top;">${itemInfo.title}</td>
                ${cells}
            </tr>`;
        }).join('');

        const noItemsRow = sortedItems.length === 0
            ? `<tr><td colspan="${2 + steps.length * 2}" style="padding:10px;text-align:center;color:#777;">Nenhum item registrado.</td></tr>`
            : '';

        const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
<meta charset="UTF-8">
<title>Relatório - ${employee.employee_name}</title>
<style>
  body { font-family: Arial, sans-serif; font-size: 11px; margin: 20px; }
  h2 { color: #2e7d32; margin-bottom: 8px; }
  .meta p { margin: 3px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 16px; }
  tr:nth-child(even) td { background: #f9f9f9; }
  @media print { body { margin: 10px; } }
</style>
</head>
<body>
<h2>Relatório de Performance</h2>
<div class="meta">
  <p><strong>Título:</strong> ${report.perforamce_title || ''}</p>
  <p><strong>Data:</strong> ${new Date().toLocaleDateString('pt-BR')}</p>
  <p><strong>Gestor:</strong> ${report.manager?.name || ''}</p>
  <p><strong>Avaliado:</strong> ${employee.employee_name}</p>
  ${employee.employee_organization ? `<p><strong>Organização:</strong> ${employee.employee_organization}</p>` : ''}
  ${employee.employee_department ? `<p><strong>Departamento:</strong> ${employee.employee_department}</p>` : ''}
</div>
<table>
  <thead>
    <tr>
      <th rowspan="2" style="background:#388e3c;color:#fff;padding:6px 8px;border:1px solid #ccc;">Sessão</th>
      <th rowspan="2" style="background:#388e3c;color:#fff;padding:6px 8px;border:1px solid #ccc;">Item</th>
      ${stepHeaders}
    </tr>
    <tr>${stepSubHeaders}</tr>
  </thead>
  <tbody>
    ${dataRows}
    ${noItemsRow}
  </tbody>
</table>
</body>
</html>`;

        const win = window.open('', '_blank');
        if (win) {
            win.document.write(html);
            win.document.close();
            win.focus();
            setTimeout(() => win.print(), 500);
        }
    }
   
    return (
        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />

            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <div className='col text-bg-green p-3'>
                        <a href='/performance-review/list/' className="fs-6 fw-bold ps-5 text-decoration-none text-white">
                            <FontAwesomeIcon className='' icon={solid('arrow-left')} /> Performance
                        </a>
                    </div>
                </div>
                <div className='my-4 mx-5 pt-3 rounded-top' style={styles}>
                    <h6 className='fw-bold'>Relatório {object?.title ? `- ${object.title}` : ''}</h6>

                    <div className='bg-white p-3 mb-2 rounded border-clean'>

                        <div className='row'>
                            <div className='col'>
                            {
                                pageLoad ?
                                <SkeletonProcess />
                                :
                                report ?
                                <>
                                <div className='col-12'>
                                        <div className='d-flex justify-content-end my-2'>
                                            <button className='btn btn-success btn-sm btn-rounded px-4' onClick={() => {
                                                exportReport()
                                            }}>
                                                Exportar
                                            </button>
                                        </div>
                                    </div>
                                {(report.assessment_type === 'SD' || report.assessment_type === 'TD') &&
                                !rootUser &&
                                report.item_comments_allowed === false ? (
                                    <div className="alert alert-secondary small py-2 mb-2" role="alert">
                                        As respostas por item (metas, competências e perguntas) exigem a permissão{' '}
                                        <strong>view_itemstatus</strong> no perfil (individual ou grupo).{' '}
                                        Usuários <strong>root</strong> (dono da empresa) visualizam sem essa permissão.
                                    </div>
                                ) : null}
                                <table className='table border-clean w-100 mb-4'>
                                    <tbody>
                                        <tr className='align-middle table-light'>
                                            <td width="20px">
                                                <Avatar title={report.manager.name} label={NameInitials( report.manager.name )} style={{ backgroundColor: '#555555', color: '#ffffff', fontWeight: 'bold' }} shape='circle' size="small" />
                                            </td>
                                            <th colSpan={2}>{report.manager.name}</th>
                                            <th colSpan={3} className='text-end'>
                                                {
                                                    report.performance_status ?
                                                    <>
                                                    {
                                                        report.performance_status === 'AT' ?
                                                        <span className='badge bg-secondary d-none'>{PERFORMANCE_STATUS_MAP[report.performance_status]}</span>
                                                        :
                                                        null
                                                    }
                                                    {
                                                        report.performance_status === 'EP' ?
                                                        <span className='badge bg-primary d-none'>{PERFORMANCE_STATUS_MAP[report.performance_status]}</span>
                                                        :
                                                        null
                                                    }
                                                    {
                                                        report.performance_status === 'CO' ?
                                                        <span className='badge bg-success d-none'>{PERFORMANCE_STATUS_MAP[report.performance_status]}</span>
                                                        :
                                                        null
                                                    }
                                                    {
                                                        report.performance_status === 'AR' ?
                                                        <span className='badge bg-secondary d-none'>{PERFORMANCE_STATUS_MAP[report.performance_status]}</span>
                                                        :
                                                        null
                                                    }
                                                    {
                                                        report.performance_status === 'CA' ?
                                                        <span className='badge bg-warning'>{PERFORMANCE_STATUS_MAP[report.performance_status]}</span>
                                                        :
                                                        null
                                                    }
                                                    </>
                                                    : null
                                                }
                                            </th>
                                        </tr>
                                    
                                
                                {report.employees && report.employees.map((employee) => (
                                    <React.Fragment key={employee.employee_id}>
                                        <tr className='align-middle'>
                                            <td width="20px">
                                                <Avatar title={employee.employee_name} label={NameInitials( employee.employee_name )} style={{ backgroundColor: '#42c0fb', color: '#ffffff', fontWeight: 'bold' }} shape='circle' size="small" />

                                            </td>
                                            <th colSpan={2}>
                                                <div className='d-flex justify-content-start align-items-center w-100'>
                                                    <span className='fw-normal'>{employee.employee_name}</span> 
                                                    <div className='ms-2 dropdown'>
                                                        <button className='btn btn-sm rounded-circle border dropdown-toggle no-caret' data-bs-toggle="dropdown" aria-expanded="false">
                                                            <FontAwesomeIcon className='text-green' icon={solid('ellipsis')} />
                                                        </button>
                                                        <ul className='dropdown-menu border headerBorder font1em'>
                                                            <li>
                                                                <button className="dropdown-item text-default" onClick={() => exportEmployeeXLS(employee)}>
                                                                    Exportar XLS
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button className="dropdown-item text-default" onClick={() => printEmployeePDF(employee)}>
                                                                    Exportar PDF
                                                                </button>
                                                            </li>
                                                            <li><hr className="dropdown-divider" /></li>
                                                            <li>
                                                                <button className="dropdown-item text-default"  data-bs-toggle="modal" data-bs-target="#formDel" onClick={() => {
                                                                    setDeleteEmployeeId(employee.employee_id)
                                                                    setDeleteEmployeeName(employee.employee_name)
                                                                    setEmployeeManagerName(report.manager.name)
                                                                    setReviewId(report.review_id)
                                                                    setEmployeeManagerId(report.manager.id)
                                                                }}>
                                                                    Remover do Processo
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                
                                            </th>
                                            <th colSpan={3} className='text-end'>
                                                {
                                                    report.performance_status !== 'CO' ?
                                                    <span className='badge bg-success'>{PERFORMANCE_STATUS_MAP[employee.final_status]}</span>
                                                    : null
                                                }
                                            </th>
                                        </tr>
                                        <tr className='table-light'>
                                            <th></th>
                                            <th>Etapa</th>
                                            <th className='text-center'>Vencimento</th>
                                            <th className='text-center'>Status</th>
                                            <th className='text-center'>Concluído em</th>
                                            <th className='text-center'>Avaliação</th>
                                        </tr>
                                        {
                                            employee.steps.map((step) => {
                                                const commentsAllowed =
                                                    rootUser || report.item_comments_allowed;
                                                const stepResponsesKey = `${employee.employee_id}-${step.step_id}`;
                                                const showResponsesIcon =
                                                    performanceReportStepResponsesAvailable(
                                                        step,
                                                        commentsAllowed,
                                                        report.assessment_type
                                                    );
                                                return (
                                                <Fragment key={step.step_id}>
                                                    <tr className='align-middle border-white'>
                                                        <td></td>
                                                        <td>
                                                            <div className='d-flex align-items-center justify-content-between gap-2 flex-wrap w-100'>
                                                                <div>
                                                                    <span>{step.step_title}</span>
                                                                    {step.step_type === 'AP' && step.action_by_name ? (
                                                                        <small className='text-muted d-block'>Par: {step.action_by_name}</small>
                                                                    ) : null}
                                                                </div>
                                                                {showResponsesIcon ? (
                                                                    <button
                                                                        type='button'
                                                                        className='btn btn-link btn-sm p-0 text-green'
                                                                        title={
                                                                            responsesOpenKey === stepResponsesKey
                                                                                ? 'Ocultar respostas'
                                                                                : 'Ver respostas'
                                                                        }
                                                                        aria-expanded={
                                                                            responsesOpenKey === stepResponsesKey
                                                                        }
                                                                        onClick={() => {
                                                                            setResponsesOpenKey((prev) =>
                                                                                prev === stepResponsesKey
                                                                                    ? null
                                                                                    : stepResponsesKey
                                                                            );
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                responsesOpenKey ===
                                                                                stepResponsesKey
                                                                                    ? solid('chevron-up')
                                                                                    : solid('comments')
                                                                            }
                                                                        />
                                                                    </button>
                                                                ) : null}
                                                            </div>
                                                        </td>
                                                        <td className='text-center'>{step.step_due_date ? moment(step.step_due_date).format("DD/MM/YYYY") : '-' }</td>
                                                        <td className='text-center'>
                                                            {
                                                                step.step_status === 'NI' ?
                                                                <span className='badge bg-danger'>{STATUS_MAP[step.step_status]}</span>
                                                                :
                                                                null
                                                            }
                                                            {
                                                                    step.step_status === 'PE' ?
                                                                    <span className='badge bg-warning'>{STATUS_MAP[step.step_status]}</span>
                                                                :
                                                                null
                                                            }
                                                            {
                                                                step.step_status === 'RE' ?
                                                                <span className='badge bg-success'>{STATUS_MAP[step.step_status]}</span>
                                                                :
                                                                null
                                                                }
                                                            
                                                        </td>
                                                        <td className='text-center'>{ step.step_date_completed ? moment(step.step_date_completed).format("DD/MM/YYYY HH:mm") : '-' }</td>
                                                        <td className='text-center'>{ step.step_score && step.step_score !== '-' ? <span className='bg-green-light-50 p-2'>{step.step_score}</span> : '-' }</td>
                                                    </tr>
                                                    <PerformanceReportStepCommentsRows
                                                        useExternalToggle
                                                        expanded={responsesOpenKey === stepResponsesKey}
                                                        onExpandedChange={(v) =>
                                                            setResponsesOpenKey(v ? stepResponsesKey : null)
                                                        }
                                                        step={step}
                                                        itemCommentsAllowed={commentsAllowed}
                                                        assessmentType={report.assessment_type}
                                                    />
                                                </Fragment>
                                                );
                                            })
                                        }
                                    </React.Fragment>
                                ))}
                                </tbody>
                                </table>
                                </>
                                :
                                <div className='text-center'>
                                    <p className='alert'>Nenhum dado encontrado para filtro aplicado.</p>
                                </div>
                            }
            
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div id="formDel" className="modal fade" ref={modalRef}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Remover Participante</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>
                                Tem certeza de que deseja remover este participante do processo?
                            </p>
                            <p>
                                Colaborador: <strong>{deleteEmployeeName}</strong>
                            <br/>
                                Líder: <strong>{employeeManagerName}</strong>
                            </p>
                            <button className="btn btn-sm btn-danger btn-rounded px-4"  onClick={deleteItem}>Sim, Remover</button>
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}